// 2020-06-27export { MyColLabelInfoComponent } from './my-col-labelinfo.component';